export default "__VITE_ASSET__heB_wmRE__"